<template>
    <div :class="burgerMenuClass">
        <snackbar :message="notification.message"></snackbar>

        <div class="menu mobile-sidebar-toggle d-md-none" @click="handleBurgerMenuClass">
            <a href="#" class="">
                <i class="dripicons-menu"></i>
            </a>
        </div>

        <div id="content-left">
            <sidebar :burgerMenuState="burgerMenuState" v-on:side-bar-class="handleBurgerMenuClass"></sidebar>
        </div>
        <div id="content-right">
            <router-view>
                <slot name="topNavigation"></slot>
                <slot name="notification"></slot>
                <slot name="breadcrumb"></slot>
                <slot></slot>
            </router-view>
        </div>
    </div>
</template>

<script>
  import Sidebar from '@/views/Common/Sidebar/Sidebar.vue';
  import Snackbar from '@/components/Snackbar/Snackbar.vue';

  export default {
    name: 'Main',
    data() {
      return {
        burgerMenuClass: 'open',
        burgerMenuState: true,
        notification: {
          message: 'Hello'
        }
      }
    },
    components: {
      Sidebar,
      Snackbar
    },

    methods: {
      handleBurgerMenuClass(value) {
        this.burgerMenuState = value;
        this.burgerMenuClass = value ? 'open' : 'closed';
      }
    }
  }
</script>

<style type="text/css" lang="scss" src="./main.scss"></style>



// WEBPACK FOOTER //
// src/views/Layout/Main.vue